import React from 'react';
import styles from 'Custom/FAQ/FAQHeader.module.scss';
import AngleDown from 'Images/brand-icons/angle-down.svg';

const FAQHeader = ({
  isExpanded,
  children,
  index = 1,
  whiteColoredborder = false,
  ...props
}) => {
  return (
    <div
      className={`${styles.faqHeader}`}
      data-qa-tag={`accordion-faqHeader-${index}`}
    >
      <button
        className={`${styles.accordionButton} ${
          whiteColoredborder ? styles.whiteBorder : ''
        }`}
        {...props}
        aria-expanded={isExpanded}
        data-design-category="accordion_vd"
        data-design-action={isExpanded ? 'Close' : 'Expand'}
        data-qa-tag={`faq-accordion-button-${index}`}
      >
        <span
          className={styles.faqItemTitle}
          data-qa-tag={`faq-accordion-title-${index}`}
        >
          {children}
        </span>
        {
          <AngleDown
            className={isExpanded ? styles.opened : styles.closed}
            data-qa-tag={`faq-accordion-title-carot-${index}`}
          />
        }
      </button>
    </div>
  );
};

export default FAQHeader;
